<template>
    <div>
        <div class="header">
            <div v-text="`渠道名称：${info.name}(ID：${info.id})`"></div>
            <div>
                <el-button
                        @click="$emit('my-close')"
                        size="small"
                        plain
                        type="primary">返回
                </el-button>
                <el-button
                        @click="submitForm('topUpConfigForm')"
                        size="small"
                        type="primary">保存
                </el-button>
            </div>
        </div>
        <el-form
                ref="topUpConfigForm"
                :model="form"
                :rules="rules"
                class="form"
                size="medium"
                label-width="110px">
            <el-form-item label="名称：" prop="name">
                <el-input placeholder="请输入" v-model="form.name"/>
            </el-form-item>
            <el-form-item label="商户号：" prop="businessNum">
                <el-input :disabled="form.id !== ''" placeholder="请输入" v-model="form.businessNum"/>
            </el-form-item>
            <el-form-item label="Key值：" prop="businessKey">
                <el-input placeholder="如果非对称公私钥加密时，则传私钥" v-model="form.businessKey"/>
            </el-form-item>
            <el-form-item label="publicKey：" prop="publicKey">
                <el-input placeholder="如果非对称公私钥加密时，公钥的值" v-model="form.publicKey"/>
            </el-form-item>
            <el-form-item label="是否使用：" prop="status">
                <el-switch
                        v-model="form.status"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="是"
                        inactive-text="否"/>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'

    export default {
        props: {
            info: Object,
            form: Object,
        },
        data() {
            return {
                rules: {
                    name: [
                        {required: true, message: '请输入名称', trigger: 'blur'}
                    ],
                    businessNum: [
                        {required: true, message: '请输入商户号', trigger: 'blur'}
                    ],
                    businessKey: [
                        {required: true, message: '请输入商户Key', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            ...mapActions('payChannel', ['updateChannel']),
            // 保存充值配置
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.updateChannel({
                            businessAccount: this.form.businessNum,
                            businessKey: this.form.businessKey,
                            id: this.info.id,
                            isUsed: this.form.status,
                            name: this.form.name,
                            paymentCode: this.form.code,
                            paymentMode: this.form.paymentMode,
                            publicKey: this.form.publicKey,
                            sdkId: this.form.id,
                            type: 0,
                        }).then(() => {
                            if(!this.form.id){
                                this.$message.success('新增成功');
                                this.$emit('my-close');
                            }else{
                                this.$message.success('保存成功');
                            }
                        })
                    }
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        display: flex;
        justify-content: space-between;
        padding-left: 5px;
    }

    .form {
        width: 500px;
        padding-right: 30px;
        margin: 35px auto 0;
    }
</style>